export enum AccountRole {
    root = 'root',
}
